import { render, staticRenderFns } from "./ActivityDurationVRPV1.vue?vue&type=template&id=9535873c&scoped=true&"
import script from "./ActivityDurationVRPV1.vue?vue&type=script&lang=js&"
export * from "./ActivityDurationVRPV1.vue?vue&type=script&lang=js&"
import style0 from "./ActivityDurationVRPV1.vue?vue&type=style&index=0&id=9535873c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9535873c",
  null
  
)

export default component.exports